import { useState } from "react";
import { useNavigate } from "react-router-dom";

// styles and images
import Close from "../../assets/close.svg";

// global
import {
  messageAndErrorStore,
  projectStore,
  userStore,
} from "../../store/Store";

// components
import DropDown from "../../formComponents/DropDown";
import FormButton from "../../formComponents/FormButton";

// internal hooks
import { useEscape } from "../../hooks/useEscape";
import { useVerifyUnique } from "../../hooks/useVerifyUnique";
import useGetFetchFromId from "../../hooks/useGetFetchFromId";
import InlineInput from "../../formComponents/InlineInput";
import NotRequired from "../../formComponents/NotRequired";

export default function SandPoPopup({
  sandPoDD,
  setSandIsTriggered,
  setEditId,
  sandId,
}) {
  // global
  const currentUser = userStore((data) => data.currentUser);
  const JwtToken = userStore((data) => data.JwtToken);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const currentProject = projectStore((data) => data.currentProject);
  const projectSandRates = projectStore((data) => data.projectSandRates);
  const setProjectSandRates = projectStore((data) => data.setProjectSandRates);
  const setProjectLoads = projectStore((data) => data.setProjectLoads);
  const setProjectTotals = projectStore((dbData) => dbData.setProjectTotals);
  const toggleNewMessage = messageAndErrorStore(
    (data) => data.toggleNewMessage,
  );

  // local
  const [newPO, setNewPO] = useState({
    id: 0,
    project_id: currentProject.project.id,
    po_number: "",
    po_id: "",
    rev_rate: 0,
    cost_rate: 0,
    created_by_id: currentUser.id,
    updated_by_id: currentUser.id,
    is_deleted: false,
    moistuire_content_rev: 0,
  });
  const [oldId, setOldId] = useState(null);
  const [pending, setPending] = useState(false);
  const navigate = useNavigate();

  var id = 0;
  if (sandId) {
    id = sandId;
  }

  const { error: retrievalError } = useGetFetchFromId(
    `${process.env.REACT_APP_BACKEND}/pc/project/sand/${id}`,
    setNewPO,
    id,
    setOldId,
    "po_id",
  );

  useEscape(setSandIsTriggered, [setEditId], [""]);

  const handleClose = () => {
    setSandIsTriggered(false);
    setEditId("");
  };

  const handleSelect = (e) => {
    setNewPO({
      ...newPO,
      po_id: e.value,
      po_number: e.label,
    });
  };

  const handleChange = (e) => {
    setNewPO({
      ...newPO,
      [e.target.name]: parseFloat(e.target.value),
    });
  };

  const { exists } = useVerifyUnique(
    projectSandRates,
    "po_id",
    newPO.po_id,
    oldId,
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    setPending(true);
    var method = "POST";
    if (id > 0) {
      method = "PATCH";
    }
    if (exists) {
      toggleNewMessage("There is already rates for this PO");
      return;
    }
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const requestBody = newPO;
    requestBody.created_by_id = currentUser.id;
    requestBody.updated_by_id = currentUser.id;
    const requestOptions = {
      method,
      headers,
      body: JSON.stringify(requestBody),
      signal: controller.signal,
    };
    fetch(
      `${process.env.REACT_APP_BACKEND}/pc/sand-rate/${newPO.id}`,
      requestOptions,
    )
      .then((res) => {
        if (res.status === 401) {
          setAuthStatus(false);
          navigate("/login");
          setPending(false);
          setSandIsTriggered(false);
          return;
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (data.error) {
          if (data.message === "project is archived cannot update") {
            toggleNewMessage("Project is Archived and cannot be updated.");
          } else {
            toggleNewMessage(data.message);
          }
          setPending(false);
        } else {
          setProjectSandRates(data.data.sand_rates);
          setProjectLoads(data.data.loads);
          setProjectTotals(data.data.all_totals);
          setSandIsTriggered(false);
          setPending(false);
          toggleNewMessage(null, "Sand PO Added");
        }
      })
      .catch((_) => {
        toggleNewMessage("Something went wrong");
        setPending(false);
      })
      .finally(() => setPending(false));
    return () => controller.abort();
  };

  return (
    <div className="popup">
      <div className="popup-inner">
        {retrievalError && <div className="error">{retrievalError}</div>}
        {!pending && (
          <div className="close">
            <img onClick={handleClose} src={Close} alt="close" />
          </div>
        )}
        <h3>Add Sand POs and Rates</h3>
        <form onSubmit={handleSubmit}>
          <DropDown
            classOne="row mb-3"
            name={"po_number"}
            title="PO#"
            options={sandPoDD}
            onChange={handleSelect}
            value={
              newPO.po_id === ""
                ? ""
                : sandPoDD.filter((x) => x.value === newPO.po_id)
            }
            placeholder="Select PO"
            classTwo="col-form-label bold-label col-sm-3"
            
          />
          <InlineInput
            type="number"
            step={0.01}
            name="rev_rate"
            title="Revenue"
            value={newPO.rev_rate === 0 ? "" : newPO.rev_rate}
            onChange={handleChange}
            required={true}
            classname="col-form-label bold-label col-sm-3"
          />
          <InlineInput
            type="number"
            step={0.01}
            name="moistuire_content_rev"
            title="Moisture%"
            value={newPO.moistuire_content_rev || ""}
            onChange={handleChange}
            classname="col-form-label bold-label col-sm-3"
          />
          <InlineInput
            type="number"
            step={0.01}
            name="cost_rate"
            title="Cost"
            value={newPO.cost_rate === 0 ? "" : newPO.cost_rate}
            onChange={handleChange}
            classname="col-form-label bold-label col-sm-3"
          />
          <FormButton pending={pending} name={"Submit"} />
        </form>
        <NotRequired/>
      </div>
    </div>
  );
}
